import { c as _c } from "react/compiler-runtime";
import type { BaseFetcher, RequestOptions } from '@newfront-insurance/browser-fetcher';
import { Fetcher } from '@newfront-insurance/browser-fetcher';
import { createContext, useContext, useMemo, type JSX } from 'react';
import * as React from 'react';
import { useNextApiBaseUrl } from './util';
export const NextApiConfigContext = createContext<NextApiSwrOptions | null>(null);
interface Props {
  children: React.ReactNode;
  mockFetcher?: BaseFetcher;
  authToken?: string | (() => Promise<string | undefined>);
}
interface NextApiSwrOptions {
  fetcher: BaseFetcher;
}
type FetchFn = <B, R>(options: RequestOptions<B>) => Promise<R | null>;

/**
 * Creates a fetcher instance with the Next API set as the base url.
 */
export function useNextApiFetch() {
  const $ = _c(2);
  const {
    fetcher
  } = useNextApiConfig();
  let t0;
  if ($[0] !== fetcher) {
    t0 = async function fetch(options) {
      const {
        data,
        error
      } = await fetcher.request(options);
      if (error) {
        throw error;
      }
      return data;
    };
    $[0] = fetcher;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const fetch = t0;
  return fetch;
}

/**
 * Creates a fetcher instance with the Next API set as the base url.
 */
export function useNextApiFetcher() {
  const {
    fetcher
  } = useNextApiConfig();
  return fetcher;
}

/**
 * Configure the Next API hooks.
 */
export function NextApiSwrProvider(props) {
  const $ = _c(8);
  const {
    children,
    mockFetcher,
    authToken
  } = props;
  const baseUrl = useNextApiBaseUrl();
  let t0;
  bb0: {
    if (mockFetcher) {
      t0 = mockFetcher;
      break bb0;
    }
    let t1;
    if ($[0] !== authToken || $[1] !== baseUrl) {
      t1 = new Fetcher({
        baseUrl,
        token: authToken
      });
      $[0] = authToken;
      $[1] = baseUrl;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    t0 = t1;
  }
  const fetcher = t0;
  let t1;
  if ($[3] !== fetcher) {
    t1 = {
      fetcher
    };
    $[3] = fetcher;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== children || $[6] !== t1) {
    t2 = <NextApiConfigContext.Provider value={t1}>{children}</NextApiConfigContext.Provider>;
    $[5] = children;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}

/**
 * Get the current Next API config object
 */
export function useNextApiConfig() {
  const legacyConfig = useContext(NextApiConfigContext);
  if (legacyConfig) {
    return legacyConfig;
  }
  throw new Error("Missing NextApiSwrProvider");
}